// extracted by mini-css-extract-plugin
module.exports = {"StormPrep-detail":"StormPrep_StormPrep-detail__bKPuU"};